import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import GoldZakatTable from './GoldZakatTable';
import { SERVER_URL } from '../ConstantsEN';
import { Gold_Zakat_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";
const TITLE = 'Gold Zakat Calculator 2026 - Gold Zakat Nisab Calculator';
const DESCRIPTION = 'The Gold Zakat Calculator is a tool used to calculate the amount of Zakat due on gold according to Islamic Shariah rules. This calculator is used to calculate the financial amount that must be paid as Zakat on owned gold.';
const KEYWORDS = 'Gold Zakat, Gold Zakat Nisab, 21 Karat, 22 Karat, 24 Karat';
const OG_URL = 'https://do-calculate.com/calculator/en/gold-zakat/';
const apiEndpoint = `${SERVER_URL}/${Gold_Zakat_EndPoint}`;
function GoldZakatCalculator() {
    const [yearType, setYearType] = useState('');
    const [gramPriceGold, setGramPriceGold] = useState(0);
    const [result, setRestul] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [goldWeights, setGoldWeights] = useState([0, 0, 0, 0, 0, 0]);
    const goldKarats = [24, 22, 21, 18, 14, 10];
    const handleWeightsChange = (index, weight) => {
        const updatedWeights = [...goldWeights];
        updatedWeights[index] = parseFloat(weight);
        setGoldWeights(updatedWeights);
    };
    const handleYearTypeChange = (event) => {
        setYearType(event.target.value);
    };
    const handleGramPriceGoldChange = (event) => {
        setGramPriceGold(event.target.value);
    };
    const calculateGoldZakat = async () => {
        const convertedGoldWeights = goldWeights.map((weight) => Number(weight));
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ goldWeights: convertedGoldWeights, goldKarats, gramPriceGold, yearType }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setRestul(data.result);
            } else {
                setRestul(null);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '15px' }}>Calculate Gold Zakat for Any Karat</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                The Gold Zakat Calculator is a tool used to calculate the amount of Zakat due on gold according to Islamic Shariah rules. This calculator is used to calculate the financial amount that must be paid as Zakat on owned gold.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '15px' }}>Gold Zakat Calculator</h2>
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='yearType' >Year Type</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="gregorian"
                                            id="gregorian"
                                            checked={yearType === "gregorian"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="gregorian">
                                            Gregorian
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="yearType"
                                            value="hijri"
                                            id='hijri'
                                            checked={yearType === "hijri"}
                                            onChange={handleYearTypeChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="hijri">
                                            Hijri
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div>
                                    {goldKarats.map((karat, index) => (
                                        <div key={index}>
                                            <div className="form-group d-flex align-items-center">
                                                <b>
                                                    <label htmlFor="amoutNumber" className="form-label ms-2">{`Gold Weight Karat ${karat}`}</label>
                                                </b>
                                                <input
                                                    type="number"
                                                    id="amoutNumber"
                                                    value={goldWeights[index]}
                                                    onChange={(e) => handleWeightsChange(index, e.target.value)}
                                                    className="form-control ml-2"
                                                    style={{ width: '75px' }}
                                                />
                                                <div className="input-group-append">
                                                    <span className="input-group-text">g</span>
                                                </div>
                                            </div>
                                            <br />
                                        </div>
                                    ))}
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='gramPriceGoldNumber' className="form-label ms-2">Price of 24 Karat Gold (per gram)</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="gramPriceGoldNumber"
                                        value={gramPriceGold}
                                        onChange={handleGramPriceGoldChange}
                                        className="form-control ml-2"
                                        style={{ width: '75px' }}
                                    />
                                </div>
                                <br/>                                <hr />
                                <button
                                    className="btn btn-success"
                                    style={{ fontSize: '20px' }}
                                    onClick={calculateGoldZakat}
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'Calculate'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter all fields correctly.</div>}
                                {result && (
                                    <div>
                                        <h4><div className="p-3 mb-2 bg-success text-white">Results:</div></h4>
                                        <hr />
                                        <GoldZakatTable result={result}></GoldZakatTable>
                                    </div>
                                )}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.islamicCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Description of Gold Zakat Calculator</div>
                            <div className="info-section-body">
                                <h2 style={{ fontSize: '15px' }}>Gold Zakat Calculator Karat 21, 22, 24 - How to Calculate Gold Zakat</h2>
                                <br />
                                The equation relies on several variables and parameters, including the weight of gold, the karat of gold, the gram price, and the type of calendar (Hijri or Gregorian). The weight of gold is converted into pure gold weight if the karat is not pure, and the total weight of pure gold is calculated.
                                <br/>                                If the total weight of pure gold exceeds the specified threshold (which is 85 grams according to the given equation), then gold zakat becomes due. The value of gold zakat is calculated using a specified percentage for zakat. Those following the Hijri calendar use a zakat percentage of the amount to be paid (2.5%), while those following the Gregorian calendar use a zakat percentage of the amount to be paid (2.577%).
                                <br/>                                After calculating the value of gold zakat, it is multiplied by the current gram price to calculate the final monetary amount to be paid as zakat.
                                <br/>                                This calculator provides the final results in the form of an object containing the total weight of pure gold and additional information such as the status of gold zakat (required or not), the monetary amount of gold zakat, and the same amount of gold zakat. Additionally, it includes the minimum weight of gold eligible for zakat.
                                <br />
                                <hr />
                                <b>Source: </b>
                                <a href="https://www.islamic-relief.me/%D8%AD%D8%B3%D8%A7%D8%A8-%D8%B2%D9%83%D8%A7%D8%A9-%D8%A7%D9%84%D9%85%D8%A7%D9%84/">
                                    Islamic Relief Worldwide
                                </a>
                                <br />
                                <b>Last Reviewed On: </b>
                                02/07/2023
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default GoldZakatCalculator;
